import React, { useState } from 'react';
import { AppBar, Paper, Tab, Tabs, ThemeProvider, createTheme, Box } from '@mui/material';
import NewMember from './NewMember';
import MemberTotal from './MemberTotal';

const customTheme = createTheme({
  palette: {
    primary: {
      main: '#fff',
    },
  },
});

const MemberScreen = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <ThemeProvider theme={customTheme}>
      <div>
        <AppBar position="static">
          <Box sx={{ maxWidth: { xs: 400, sm: 680 }, bgcolor: 'background.paper' }}>
            <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons
              allowScrollButtonsMobile
              aria-label="scrollable force tabs example"
            >
              <Tab label="신입회원" style={{ color: '#194C86', marginLeft: '-15px' }} />
              <Tab label="클럽별 신입회원 명단" style={{ color: '#941B4C', marginLeft: '-15px' }} />
            </Tabs>
          </Box>
        </AppBar>
        <Paper>
          {value === 0 && <NewMember />}
          {value === 1 && <MemberTotal />}
        </Paper>
      </div>
    </ThemeProvider>
  );
};

export default MemberScreen;
